const { pickBy, findKey, sortBy, isEmpty, } = require('lodash');

const { entries } = Object;

// レビュー依頼の送信タイミング(お届け予定日からの経過日数)。
// Amazonの送信可能ウィンドウは EarliestDeliveryDate の5日後〜LatestDeliveryDate の30日後。
// この範囲内の値のみ選択肢として提示する。
const reviewRequestTimingOptions = [
  { label: 'お届け予定日の5日後', value: 5 },
  { label: 'お届け予定日の7日後', value: 7 },
  { label: 'お届け予定日の10日後', value: 10 },
  { label: 'お届け予定日の14日後', value: 14 },
  { label: 'お届け予定日の21日後', value: 21 },
];

// amazonOrders のドキュメントID。同一テナントに複数セラーがいる場合に amazonOrderId が衝突して
// 相互に上書きされるのを防ぐため、sellerId を含む複合キーにする。
// バックエンド(requestReviews.js)とフロント(ReviewRequests.jsx)で同じキーを使うため共有モデルに置く。
const orderDocId = (sellerId, amazonOrderId) => `${sellerId}__${amazonOrderId}`;

const fields = () => {
  return {
    name: {
      type: 'string',
      label: '名称',
      validations: {
        required: v => !isEmpty(v),
      },
    },
    reviewRequestEnabled: {
      type: 'boolean',
      label: 'レビュー・評価依頼を自動送信する',
      initialValue: false,
    },
    reviewRequestTimingDays: {
      type: 'select',
      label: '送信タイミング',
      options: reviewRequestTimingOptions,
      initialValue: 7,
      hidden: state => state.reviewRequestEnabled !== true,
    },
  };
};

exports.fields = fields;
exports.reviewRequestTimingOptions = reviewRequestTimingOptions;
exports.orderDocId = orderDocId;
